// extracted by mini-css-extract-plugin
module.exports = {"black":"IconButtonMoons_black__2lGw1"};